<script setup lang="ts">
import { computed } from 'vue'
import type { ExternalCourse } from '@/models/current-student-advanced-standing-form/api'
import type {
  ArticulationCondition,
  ArticulationTableRow,
} from '@/models/current-student-advanced-standing-form/precedents'

const props = defineProps<{
  course: ExternalCourse
  articulationRows: (course: ExternalCourse) => ArticulationTableRow[]
  articulationConditions: (course: ExternalCourse) => ArticulationCondition[]
}>()

const rows = computed(() => props.articulationRows(props.course))
const conditions = computed(() => props.articulationConditions(props.course))
</script>

<template>
  <table
    v-if="rows.length > 0"
    class="table table-sm PrecedentsTable PrecedentsTableCourses"
  >
    <thead>
      <tr>
        <th colspan="2">Articulation Agreements</th>
        <th colspan="4">Matching La Trobe Articulation Subjects</th>
      </tr>
      <tr>
        <th>Reference</th>
        <th class="hideRightBorder"></th>
        <th class="hideLeftBorder">Code</th>
        <th colspan="2">Name</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in rows" :key="row.key">
        <td v-if="row.showAgreementReference" :rowspan="row.agreementRowspan">
          {{ row.agreementReference }}
        </td>
        <td
          v-if="row.showGroupLabel"
          class="middleCol"
          :class="{ hideRightBorder: row.groupRowspan === 1 }"
          :rowspan="row.groupRowspan"
        >
          <div>{{ row.groupRowspan > 1 ? 'One of' : '' }}</div>
        </td>
        <td :class="{ hideLeftBorder: row.groupRowspan === 1 }">
          {{ row.subject.subject_code }}<sup v-if="row.conditionIndex">{{ row.conditionIndex }}</sup>
        </td>
        <td>{{ row.subject.subject_name }}</td>
      </tr>
    </tbody>
  </table>
  <h4 v-if="conditions.length > 0">Articulation Conditions</h4>
  <ol v-if="conditions.length > 0">
    <li v-for="condition in conditions" :key="condition.index">
      {{ condition.text }}
    </li>
  </ol>
</template>
